import { render, staticRenderFns } from "./HomePageHero.vue?vue&type=template&id=afedef18"
import script from "./HomePageHero.vue?vue&type=script&lang=js"
export * from "./HomePageHero.vue?vue&type=script&lang=js"
import style0 from "./HomePageHero.vue?vue&type=style&index=0&id=afedef18&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HomePageHero.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports